import instance from '../../utils/axiosConfig';

/**
 * 대상자 어노테이션 업데이트 API
 * @param {Object} annotData - 대상자 어노테이션 정보
 * @param {number} annotData.id - 대상자 ID
 * @param {string} annotData.annotation - 어노테이션 정보
 * @returns {Promise} API 응답
 */
export const updateClinicalAnnotation = async (annotData) => {
    try {
        const response = await instance.patch(`/api/v1/clinical/user`, annotData);
        return response.data;
    } catch (error) {
        throw error;
    }
};
